module.exports = __webpack_public_path__ + "static/media/slider_technologia-myjaca.b3076c09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider_technologia-myjaca.jpg
// module id = 831
// module chunks = 0